import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import _ from 'lodash';
import * as io from 'socket.io-client';

import { Session } from '../../models/Sessions/Session';

@Injectable()
export class SessionsSocketService {
  private socket: io.Socket;
  private listeners: any[];

  connect(token: string) {
    if (token && !this.socket) {
      this.socket = io.connect(environment.backend + '/sessions', {
        path: '/socket.io-client',
        query: { token },
      });

      // this.sessionSocket.on('error', err => Raven.captureMessage(err));
      this.socket.on('error', err => console.error(err));
      this.listeners = [];
    }
  }

  disconnect() {
    if (this.socket && this.socket.connected) {
      this.socket.disconnect();
      this.socket = undefined;
    }
  }

  /**
   * Register listeners to sync all existing sessions.
   * Takes a referece to the session array.
   * @param sessions
   */
  syncUpdates(sessions: Session[]) {
    const addListener = (event, callback) => {
      if (this.socket) {
        this.socket.on(event, callback);
        this.listeners.push(event);
      }
    };

    addListener('session:create', update => {
      sessions.push(update);
    });
  }

  /**
   * Removes listeners for updates on the socket
   */
  unsyncUpdates() {
    if (this.socket) {
      _.forEach(this.listeners, event => this.socket.removeListener(event));
    }
    this.listeners = [];
  }
}
